/**
 * Created by imranexpt on 18/06/2017.
 */
(function() {
    /** @ngInject */
    function baseController($scope,  $http,Booking){
        $scope.restaurant = restaurant_name;
        var doingAjax = false;
        $scope.hideLanguageCtrl = true;
        $scope.langid = langid;
        $scope.settings = settings;
        $scope.booking = Booking;
        $scope.booking.initFromDbObj(_booking);
        $scope.invite_form = {firstname : '', lastname : '', email : '', mobile : ''};

        $scope.daily_message = '';
        $scope.isIframe = window.location !== window.parent.location;
        //console.log(window.parent);
        $scope.date = Booking.getDate('YYYY-MM-DD');
        var _changeLang = false;
        /*if(!navigator.cookieEnabled){
            alert("Please make sure cookies are enabled before making reservation");
            return;
        }*/
        $scope.changingLanguage = function(update){
            if(!_.isUndefined(update)) _changeLang = update;
            return _changeLang;
        };
        $scope.reloadLanguage = function(lang){
            window.location = '/reservation/?hash=' + hash + '&lang=' + lang;
            return;
        };
        $scope.format_date = function(stamp, format){
            if(_.has(settings,'timezone')){
                return moment.tgz(stamp).tz(settings.timezone).format(format);
            }
            return moment.tgz(stamp).format(format);
        };
        $scope.signalClose = function(){
            if(window.self === window.top && window.history.length >= 1) {
                window.history.go(-1);
                return;
            }
            if(typeof(window.parent) !== 'undefined') {
                window.parent.postMessage('closeWaiteraidFrame', "*");
            }
        };
        $scope.isPopupFrame = function(){
            return window.self !== window.top;
        };


        $scope.isAjaxRequest = function(){
            //if(doingAjax === true) return true;
            return $http.pendingRequests.length > 0;
        };

        $scope.template = $scope.booking.do_confirm == 0 ? '' : 'confirm';

        $scope.setTemplate = function(t){
            $scope.template = t;
        };
        $scope.doingAjax = function(){ return doingAjax; };
        $scope.setAjaxMode =  function(mode){
            doingAjax = mode;
        };
        function getTotal(){
            var total = 0;
            if($scope.booking.products){
                _.forEach($scope.booking.products, function(p){
                    total += p.amount*p.meal_price;
                });
            }
            return total;
        }
        window.setTimeout(function(){
            if(localStorage.getItem("Reservation-Details-Event") !== Booking.book_id) {
                if (typeof (dataLayer) !== 'undefined') {
                    var bookingObj = {
                        'regDate': moment().format('YYYY-MM-DD HH:mm'),
                        'bookingDate': $scope.booking.getDate("YYYY-MM-DD"),
                        'bookingTime': $scope.booking.time_formatted,
                        'quantity': $scope.booking.amount,
                        'totalAmount': getTotal().toFixed(2),
                        'products' : _.size($scope.booking.products),
                        'meal' : $scope.booking.meal.name,
                        'amount' : $scope.booking.amount,
                        'date' : $scope.booking.getDate("YYYY-MM-DD"),
                        'time' : $scope.booking.time_formatted,
                        'averageValue' : _booking.meal.avg_gtm_price,
                        'totalValue' : (_booking.meal.avg_gtm_price*_booking.amount)
                    };
                    updateWidgetStep('Reservation-Details', bookingObj);
                    //dataLayer.push({'event': 'Reservation-Details'});
                    localStorage.removeItem("Reservation-Details-Event");
                    localStorage.setItem("Reservation-Details-Event",Booking.book_id);
                }
            }
        },1000);
    }

    angular.module("Waiteraid").controller("baseController", baseController);
})();
